(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qualuca-home-offers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qualuca-home-offers')) {
    customElements.define('qualuca-home-offers', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.qho__track');
        this.slides = [...this.querySelectorAll('.qho__slide')];
        this.dots = [...this.querySelectorAll('.qho__dot')];
        this.status = this.querySelector('.qho__status');
        this.index = 0;
        this.frame = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!this.track || !this.slides.length) return;
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.go(this.current() + Number(button.dataset.direction)), options));
        this.dots.forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.index)), options));
        this.track.addEventListener('keydown', event => {
          const next = { ArrowLeft:this.current()-1, ArrowRight:this.current()+1, Home:0, End:this.slides.length-1 }[event.key];
          if (next === undefined) return;
          event.preventDefault();
          this.go(next);
        }, options);
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame=0; this.update(); });
        }, { ...options, passive:true });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.go(index, true);
        }, options);
        this.resize = new ResizeObserver(() => this.go(this.index, true));
        this.resize.observe(this.track);
        const controls = this.querySelector('.qho__controls');
        if (controls) controls.hidden=false;
        this.update();
      }
      current() {
        return Math.max(0, Math.min(this.slides.length-1, Math.round(this.track.scrollLeft / Math.max(1,this.track.clientWidth))));
      }
      go(index, instant=false) {
        const next = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left:next*this.track.clientWidth, behavior:instant||this.reduced.matches?'instant':'smooth' });
      }
      update() {
        const next = this.current();
        this.index = next;
        this.dots.forEach((dot,i) => dot.setAttribute('aria-current',String(i===next)));
        if (this.status && this.status.textContent !== this.slides[next].dataset.status) this.status.textContent=this.slides[next].dataset.status;
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
        this.abort=null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
